import React, { useEffect } from 'react';
import { Checkbox } from 'antd';
import PresenceOfficeSwitch from './leOfficeSwitch';

const LE_PRESENCE = 'LE Presence';
const OFFICES = 'Offices';

const CheckboxGroup = ({
  buyerChecked,
  targetChecked,
  setBuyerChecked,
  setTargetChecked,
  buyerOfficeChecked,
  targetOfficeChecked,
  setBuyerOfficeChecked,
  setTargetOfficeChecked,
  buyerLabel,
  targetLabel,
  expand,
  onPresenceOfficeSwitchChange,
  isDisplayPresence,
}) => {
  useEffect(() => {
    if (expand) {
      setBuyerChecked(true);
      setTargetChecked(true);
      setBuyerOfficeChecked(true);
      setTargetOfficeChecked(true);
    } else {
      setBuyerChecked(true);
      setTargetChecked(true);
      setBuyerOfficeChecked(false);
      setTargetOfficeChecked(false);
      onPresenceOfficeSwitchChange(false);
    }
  }, [expand]);

  if (!expand) {
    return (
      <div className="input-label">
        {!expand && (
          <PresenceOfficeSwitch onChange={onPresenceOfficeSwitchChange} />
        )}
        {expand}
        <div>
          <Checkbox
            onChange={() => {
              if (isDisplayPresence) {
                setBuyerChecked(!buyerChecked);
              } else {
                setBuyerOfficeChecked(!buyerOfficeChecked);
              }
            }}
            checked={isDisplayPresence ? buyerChecked : buyerOfficeChecked}
          >
            {buyerLabel}
          </Checkbox>
          <Checkbox
            onChange={() => {
              if (isDisplayPresence) {
                setTargetChecked(!targetChecked);
              } else {
                setTargetOfficeChecked(!targetOfficeChecked);
              }
            }}
            checked={isDisplayPresence ? targetChecked : targetOfficeChecked}
          >
            {targetLabel}
          </Checkbox>
        </div>
      </div>
    );
  }
  return (
    <div className="input-label">
      <div className="side-labels">
        <div className="a-side-label">
          <div className="yellow-dot" />
          {buyerLabel}
        </div>
        <div className="a-side-label">
          <div className="blue-dot" />
          {targetLabel}
        </div>
      </div>
      <div className="presence-checkbox-group">
        <Checkbox
          onChange={() => {
            setBuyerChecked(!buyerChecked);
          }}
          checked={buyerChecked}
        >
          {LE_PRESENCE}
        </Checkbox>
        <Checkbox
          onChange={() => {
            setTargetChecked(!targetChecked);
          }}
          checked={targetChecked}
        >
          {LE_PRESENCE}
        </Checkbox>
      </div>
      <div className="office-checkbox-group">
        <Checkbox
          onChange={() => {
            setBuyerOfficeChecked(!buyerOfficeChecked);
          }}
          checked={buyerOfficeChecked}
        >
          <span
            className="appkiticon icon-location-fill"
            style={{ color: 'var(--buyerYellow)' }}
          />
          {OFFICES}
        </Checkbox>
        <Checkbox
          onChange={() => {
            setTargetOfficeChecked(!targetOfficeChecked);
          }}
          checked={targetOfficeChecked}
        >
          <span
            className="appkiticon icon-location-fill"
            style={{ color: '#0089EB' }}
          />
          {OFFICES}
        </Checkbox>
      </div>
    </div>
  );
};

export default CheckboxGroup;
